// Client portal: optional autopay. The card is saved at Stripe on the
// business's own account (Stripe-hosted page); recurring invoices are then
// paid automatically. The client can turn it off or remove the card any time.
import React, { useCallback, useEffect, useState } from 'react';
import portalAPI from './portalApi';
import { formatApiError } from '../../utils/errorMessage';

export default function PortalAutopay() {
  const [state, setState] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setState((await portalAPI.autopay()).data); } catch (e) { setState(null); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const run = async (fn, fallback) => {
    setBusy(true); setError('');
    try { await fn(); } catch (e) { setError(formatApiError(e, fallback)); }
    setBusy(false);
  };
  if (!state || (!state.available && !state.card)) return null;
  return (
    <section aria-label="Autopay" className="border rounded p-3 text-sm space-y-2">
      <h2 className="font-semibold">Automatic payments</h2>
      {state.card ? (
        <>
          <p>Saved card: {state.card.brand} ending in {state.card.last4}</p>
          <label className="flex items-center gap-2">
            <input type="checkbox" aria-label="Pay recurring invoices automatically" checked={state.enabled} disabled={busy || !state.available}
              onChange={(e) => run(async () => setState((await portalAPI.setAutopay(e.target.checked)).data), 'Could not change autopay')} />
            Pay recurring invoices automatically with this card
          </label>
          <div className="flex gap-3">
            {state.available && <button type="button" disabled={busy} className="underline" onClick={() => run(async () => window.location.assign((await portalAPI.autopaySetup()).data.url), 'Could not open the card page')}>Use a different card</button>}
            <button type="button" disabled={busy} className="underline text-red-600" onClick={() => run(async () => setState((await portalAPI.removeCard()).data), 'Could not remove the card')}>Remove card</button>
          </div>
        </>
      ) : (
        <>
          <p>Save a card and your recurring invoices are paid automatically when they are issued. You can turn this off at any time.</p>
          <button type="button" disabled={busy} className="border rounded px-3 py-1" onClick={() => run(async () => window.location.assign((await portalAPI.autopaySetup()).data.url), 'Could not open the card page')}>Save a card for autopay</button>
        </>
      )}
      {error && <p role="alert" className="text-red-600 text-xs">{error}</p>}
    </section>
  );
}
